import React from 'react';
import { Clock, RotateCcw } from 'lucide-react';

interface WeightEditorProps {
    category: string;
    weight: number;
    isModified: boolean;
    isRecalculating: boolean;
    colors: {
        bg: string;
        text: string;
        icon: string;
    };
    onWeightChange: (newWeight: number) => void;
    onResetWeight: () => void;
}

const WeightEditor: React.FC<WeightEditorProps> = ({
    category,
    weight,
    isModified,
    isRecalculating,
    colors,
    onWeightChange,
    onResetWeight
}) => {
    return (
        <div className="space-y-2">
            <div className="flex items-center justify-between">
                <span className={`text-sm ${colors.text} opacity-75`}>Weight:</span>
                <div className="flex items-center gap-2">
                    {isModified && (
                        <div className="flex items-center gap-1">
                            <Clock className="w-3 h-3 text-orange-500" />
                            <span className="text-xs text-orange-600 font-medium">Modified</span>
                        </div>
                    )}
                    <span className={`text-sm font-medium ${colors.text}`}>
                        {Math.round(weight * 100)}%
                    </span>
                </div>
            </div>
            <div className="weight-progress-bar">
                <div
                    className="weight-progress-fill"
                    style={{
                        width: `${weight * 100}%`,
                        backgroundColor: colors.icon.replace('text-', '').replace('-600', '')
                    }}
                ></div>
            </div>

            {/* Inline Weight Editor */}
            <div className="weight-editor-container group-hover:opacity-100">
                <div className="flex items-center justify-between gap-2">
                    {isModified && (
                        <button
                            onClick={onResetWeight}
                            className="flex items-center gap-1 px-2 py-1 text-xs text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded transition-colors"
                            disabled={isRecalculating}
                            title="Reset to original value"
                        >
                            <RotateCcw className="w-3 h-3" />
                            Reset
                        </button>
                    )}
                    {!isModified && <div />} {/* Spacer when no reset button */}

                    <input
                        type="number"
                        min="0"
                        max="1"
                        step="0.01"
                        value={weight}
                        onChange={(e) => {
                            const newWeight = parseFloat(e.target.value) || 0;
                            onWeightChange(newWeight);
                        }}
                        className="weight-input"
                        placeholder="0.00"
                        disabled={isRecalculating}
                    />
                </div>
            </div>
        </div>
    );
};

export default WeightEditor;